import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit, Optional, signal, ViewChild, ViewEncapsulation } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { firstValueFrom, Subscription } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { GameSettingsService } from 'src/app/core/firebase/gameSettings.service';
import { GameThemeSettingsDispatcher } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.dispatcher';
import { IAvatar } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.state';
import { ProfileStateDispatcher } from 'src/app/core/state/profile/profile.dispatcher';
import { SOPO_DIALOG_DATA, SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';
import SwiperCore, { Navigation, SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

SwiperCore.use([Navigation]);

const FORBIDDEN_IDS = [85, 86, 93];

@Component({
    selector: 'app-avatars',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './avatars.component.html',
    styleUrls: ['./avatars.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AvatarsComponent implements OnInit {
    @Input() isInline = false;
    @ViewChild('avatarSlide') avatarSlide: SwiperComponent;
    errorMsg: string;
    avatarSubscription: Subscription;
    avatars: IAvatar[] = [];
    unlockedAvatars: IAvatar[] = [];
    photoUrl = signal<number>(0);
    useNftAvatar = false;
    sliderOptions: SwiperOptions = {
        slidesPerView: 4,
        pagination: false,
        navigation: true,
    };

    constructor(
        private profileStateDispatcher: ProfileStateDispatcher,
        private popoverController: PopoverController,
        private gameSettingsService: GameSettingsService,
        private ref: ChangeDetectorRef,
        private gameThemeSettingsDispatcher: GameThemeSettingsDispatcher,
        @Optional() public sopoDialogRef: SopoDialogRef,
        @Optional() @Inject (SOPO_DIALOG_DATA) public data: any,
    ) { }

    async ngOnInit() {
        this.errorMsg = '';
        this.avatarSubscription = this.gameThemeSettingsDispatcher.getMyAvatarsState().subscribe((avatars) => {
            this.avatars = avatars.filter(avatar => !FORBIDDEN_IDS.includes(avatar.id));
            this.ref.markForCheck();
        });
        const profileState = await firstValueFrom(this.profileStateDispatcher.getProfileState());
        this.photoUrl.set(profileState.profileData.photoURL as number);
        this.useNftAvatar = profileState.profileData.useNftAsAvatar;       
        this.ref.markForCheck(); 
    }

    ngOnDestroy() {
        if (this.avatarSubscription) {
            this.avatarSubscription.unsubscribe();
        }
    }

    onSelect(pic: IAvatar) {
        if (pic.id != this.photoUrl()) {
            this.gameSettingsService.changeSetting(pic, 'avatars');
            if (this.sopoDialogRef) this.sopoDialogRef.close();
            else if (this.data) this.popoverController.dismiss();
            this.photoUrl.set(pic.id);
        }
    }

    trackAvatars(index: number, avatar: IAvatar): number {
        return avatar.id;
    }
}
